import { Button, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { PAGE_SIZE, PAGE_SIZE_OPTIONS, TYPE_PAGE, VEHICLE_CAPACITY, VEHICLE_CATEGORY } from '../../constants';
import { selectAllVehicles } from '../../modules/vehicles/stores/slice';
import { doCreateVehicle, doGetVehicles, doUpdateVehicle } from '../../modules/vehicles/stores/thunk';
import VehicleForm from '../Forms/Vehicles/VehicleForm';
import VehiclesTable from '../Tables/VehiclesTable';
import withPage from './withPage';
import usePageView from '../../hooks/usePageView';

const VehiclesPage = ({ query, pushTo }) => {
  const dispatch = useDispatch();

  const isFetching = useSelector((state) => state.vehicle.isFetching);
  const action = useSelector((state) => state.vehicle.action);
  const status = useSelector((state) => state.vehicle.status);
  const metadata = useSelector((state) => state.vehicle.metadata);
  const vehicles = useSelector((state) => selectAllVehicles(state));

  const [vehicleDetail, setVehicleDetail] = useState();
  const [typeVehicle, setTypeVehicle] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  // Emit page view event
  usePageView(window.location.href);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  useEffect(() => {
    setSearchValue(query.q || '');
  }, []);

  const currentPage = Number(query.current) || 1;
  const itemsPerPage = Number(query.pageSize) || PAGE_SIZE;

  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    locale: { items_per_page: 'Vehicles/Page' },
    total: metadata?.totalItems || 0,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    showSizeChanger: true,
    showTotal: (total) => `${total} Vehicles`,
  };

  useEffect(() => {
    dispatch(doGetVehicles({ page: currentPage, take: itemsPerPage, ...query }));
  }, []);

  useEffect(() => {
    if (['create', 'update'].includes(action) && status === 'succeeded') {
      dispatch(doGetVehicles({ page: currentPage, take: itemsPerPage, ...query }));
      cancelModal();
    }
  }, [isFetching]);

  const onClickEditRider = (id) => {
    setTypeVehicle(TYPE_PAGE.EDIT);
    const editVehicle = vehicles.find((vehicle) => vehicle.id === id);
    setVehicleDetail({
      ...editVehicle,
      startAddress: {
        address: editVehicle.startAddress,
        latLng: {
          lat: editVehicle.startAddressLat,
          lng: editVehicle.startAddressLng,
        },
      },
      endAddress: {
        address: editVehicle.endAddress,
        latLng: {
          lat: editVehicle.endAddressLat,
          lng: editVehicle.endAddressLng,
        },
      },
    });
    setIsModalOpen(true);
  };

  const handleActionVehicle = (data) => {
    const params = {
      ...data,
      capacity: VEHICLE_CAPACITY[data.vehicleType],
      vehicleCategory: VEHICLE_CATEGORY[data.vehicleType],
    };
    if (vehicleDetail && typeVehicle === TYPE_PAGE.EDIT) {
      params.id = vehicleDetail.id;
      dispatch(doUpdateVehicle({ ...params }));
    } else {
      dispatch(doCreateVehicle({ ...params }));
    }
  };

  const handleFilter = (params, updatePath) => {
    delete params.pageSizeOptions;
    if (updatePath) {
      pushTo({ query: params });
    }
    const newCurrentPage = Number(params?.current || 1);
    const newItemsPerPage = Number(params?.pageSize) || PAGE_SIZE;
    dispatch(
      doGetVehicles({
        page: newCurrentPage,
        take: newItemsPerPage,
        ...params,
      }),
    );
  };

  const handleChangeSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearch = () => {
    handleFilter({ q: searchValue || '' }, true);
  };

  const cancelModal = () => {
    if (vehicleDetail) setVehicleDetail(undefined);
    setIsModalOpen(false);
  };

  const onClickNewRider = () => {
    setTypeVehicle(TYPE_PAGE.NEW);
    setIsModalOpen(true);
  };

  const withAction = (record) => {
    return (
      <div className="actions">
        <Button type="link" className="edit">
          <ReactSVG className="icon" src="/icons/edit.svg" onClick={() => onClickEditRider(record.id)} />
        </Button>
        {/* <Button type="link" className="more">
          <ReactSVG className="icon" src="/icons/more.svg" />
        </Button> */}
      </div>
    );
  };

  const handleTableChange = (params) => {
    const newParams = { ...query, ...params };
    handleFilter(newParams, true);
  };

  return (
    <Spin spinning={isFetching}>
      <div className="Content VehiclesPage">
        <div className="ContentHeader">
          <div className="HeaderTitle">VEHICLES</div>
          <div className="HeaderToolBar">
            <div className="ToolBarButtons">
              <Button className="CreateButton ButtonPrimary" type="primary" size="small" onClick={onClickNewRider}>
                Create New Vehicle
                <ReactSVG className="icon" src="/icons/plus.svg" />
              </Button>
            </div>
          </div>
        </div>
        <div className="ContentMain">
          <VehiclesTable
            onChange={handleTableChange}
            dataSource={vehicles}
            pagination={pagination}
            searchValue={searchValue}
            withAction={withAction}
            onSelectChange={onSelectChange}
            selectedRowKeys={selectedRowKeys}
            onSearch={handleSearch}
            onChangeSearch={handleChangeSearch}
            rowKey="vehicleId"
            isFetching={isFetching}
          />
        </div>

        <Modal
          width={552}
          closeIcon={false}
          title={typeVehicle === TYPE_PAGE.NEW ? 'Create New Vehicle' : 'Edit Vehicle'}
          open={isModalOpen}
          forceRender
        >
          <VehicleForm
            handleCancel={cancelModal}
            handleOk={(values) => handleActionVehicle(values)}
            isModalOpen={isModalOpen}
            vehicle={vehicleDetail}
            typePage={typeVehicle}
            isFetching={isFetching}
          />
        </Modal>
      </div>
    </Spin>
  );
};

export default withPage(VehiclesPage);
